import { render } from "./Wangeditor.vue?vue&type=template&id=fd154b0c"
import script from "./Wangeditor.vue?vue&type=script&lang=js"
export * from "./Wangeditor.vue?vue&type=script&lang=js"

import exportComponent from "D:\\lpl\\szy\\cloud-api-web-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__